import axios from 'axios';
import {
  FETCH_ADDRESSBOOK_ADDRESSES_BEGIN,
  FETCH_ADDRESSBOOK_ADDRESSES_SUCCESS,
  FETCH_ADDRESSBOOK_ADDRESSES_FAIL,
  CREATE_ADDRESSBOOK_ADDRESS_SUCCESS,
  CREATE_ADDRESSBOOK_ADDRESS_FAIL,
  UPDATE_ADDRESSBOOK_ADDRESS_SUCCESS,
  UPDATE_ADDRESSBOOK_ADDRESS_FAIL,
  DELETE_ADDRESSBOOK_ADDRESS_SUCCESS,
  DELETE_ADDRESSBOOK_ADDRESS_FAIL,
  ENABLE_ADDRESSBOOK_WHITELIST_SUCCESS,
  ENABLE_ADDRESSBOOK_WHITELIST_FAIL,
  DISABLE_ADDRESSBOOK_WHITELIST_SUCCESS,
  DISABLE_ADDRESSBOOK_WHITELIST_FAIL,
} from './types';

export const fetchAddresses = (params) => async (dispatch) => {
  dispatch({type: FETCH_ADDRESSBOOK_ADDRESSES_BEGIN});
  const url = process.env.REACT_APP_API_URL + '/private/address';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_ADDRESSBOOK_ADDRESSES_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_ADDRESSBOOK_ADDRESSES_FAIL, errors: error });
    }
    return dispatch({ type: FETCH_ADDRESSBOOK_ADDRESSES_FAIL });
  }
};

export const addNewAddress = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + `/private/address`;
  try {
    const response = await axios.post(url, data);
    return dispatch({ type: CREATE_ADDRESSBOOK_ADDRESS_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: CREATE_ADDRESSBOOK_ADDRESS_FAIL, errors: error });
    }
    return dispatch({ type: CREATE_ADDRESSBOOK_ADDRESS_FAIL });
  }
};

export const updateAddress = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + `/private/address/${data.referenceId}`;
  try {
    const response = await axios.patch(url, data);
    return dispatch({ type: UPDATE_ADDRESSBOOK_ADDRESS_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: UPDATE_ADDRESSBOOK_ADDRESS_FAIL, errors: error });
    }
    return dispatch({ type: UPDATE_ADDRESSBOOK_ADDRESS_FAIL });
  }
};

export const deleteAddress = (data, params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + `/private/address/${data.referenceId}`;
  try {
    const response = await axios.delete(url, {params});
    return dispatch({ type: DELETE_ADDRESSBOOK_ADDRESS_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: DELETE_ADDRESSBOOK_ADDRESS_FAIL, errors: error });
    }
    return dispatch({ type: DELETE_ADDRESSBOOK_ADDRESS_FAIL });
  }
};

export const enableAddressbookWhitelist = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + `/private/addressWhitelist`;
  try {
    const response = await axios.post(url, data);
    return dispatch({ type: ENABLE_ADDRESSBOOK_WHITELIST_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: ENABLE_ADDRESSBOOK_WHITELIST_FAIL, errors: error });
    }
    return dispatch({ type: ENABLE_ADDRESSBOOK_WHITELIST_FAIL });
  }
};

export const disableAddressbookWhitelist = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + `/private/addressWhitelist`;
  try {
    const response = await axios.delete(url, { params });
    return dispatch({ type: DISABLE_ADDRESSBOOK_WHITELIST_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: DISABLE_ADDRESSBOOK_WHITELIST_FAIL, errors: error });
    }
    return dispatch({ type: DISABLE_ADDRESSBOOK_WHITELIST_FAIL });
  }
};
